module.exports = __webpack_public_path__ + "img/DE01286.84a462c4.png";